<template>
  <div id="knowledgePage">
    <div class="knowledgeContainer">
      <!-- 搜索条件行 -->
      <div class="searchRow">
        <el-input class="tableSearch" v-model="searchInfo1" placeholder="标题内容搜索"></el-input>
        <div class="btnCol">
          <el-button class="search" @click="handleSearch">查询</el-button>
          <el-button class="creat" style="background-color:#40A0F2;" @click="addKnowledgeClick">新建</el-button>
          <img
            style="width:24px"
            v-if="showKnowledgeListType=='2'"
            src="../../assets/image/icon_lb2@2x.png"
            alt
          />
          <img
            @click="showKnowledgeListTypeChange('2')"
            v-if="showKnowledgeListType=='1'"
            style="width:24px"
            src="../../assets/image/icon_lb@2x.png"
            alt
          />
          <img
            style="width:27px"
            v-if="showKnowledgeListType=='1'"
            src="../../assets/image/icon_pp@2x.png"
            alt
          />
          <img
            @click="showKnowledgeListTypeChange('1')"
            v-if="showKnowledgeListType=='2'"
            style="width:27px"
            src="../../assets/image/icon_pp2@2x.png"
            alt
          />
        </div>
      </div>
      <!-- 知识库-方块 -->
      <ul class="knowledgeListChunk" v-if="showKnowledgeListType==='1' && knowledgeList.length>0">
        <li v-for="(item,index) in knowledgeList" :key="item.id" @click="showDetails(item)">
          <h3>
            更新时间 {{item.update_time}}
            <i
              @click.stop="removeKnow(item)"
              v-if=" isAdmin==0 ? true : false"
              class="el-icon-close"
            ></i>
          </h3>
          <div class="body">
            <div class="bodyTitle">{{item.title}}</div>
            <p>
              <span style="color:#999">相关项目类型：</span>
              <span>{{item.project_type}}</span>
            </p>
            <p class="containerp">
              <span style="color:#999">内容：</span>
              <span>{{item.content}}</span>
            </p>
            <div class="creatPeople">
              <span style="width:25%;color:#333">创建人</span>
              <img v-if="item.member" :src="item.member.avatar" alt />
              <span v-if="item.member" style="font-size:16px;color:#666">{{item.member.nickname}}</span>
            </div>
            <div class="creatPeople" style="border-bottom:none;">
              <span style="width:25%;color:#333">编辑人员</span>
              <img v-if="item.editor.length>=1" :src="item.editor[0].avatar" alt />
              <img v-if="item.editor.length>=2" :src="item.editor[1].avatar" alt />
              <div class="moreDrop" style="height:50%;display:flex;align-items: center;">
                <img
                  @click.stop="activeDorpListClick(item.id)"
                  style="height:35px;"
                  src="../../assets/image/morePeople.png"
                  alt
                />
                <!-- 向右 -->
                <div v-if="activeDorpList == item.id && (index+1)%3!=0" class="dropBody">
                  <div class="creatPeople">创建人</div>
                  <div class="headerBox">
                    <div class="ceatPeopleInfo">
                      <img v-if="item.member" :src="item.member.avatar" alt />
                      <span v-if="item.member">{{item.member.nickname}}</span>
                    </div>
                  </div>
                  <div class="creatPeople">编辑人员</div>
                  <div class="headerBox">
                    <div class="ceatPeopleInfo" v-for="items in item.editor">
                      <img :src="items.avatar" alt />
                      <span>{{items.nickname}}</span>
                    </div>
                  </div>
                  <div class="border-up-empty"></div>
                </div>
                <!-- 向左 -->
                <div
                  v-if="activeDorpList == item.id && (index+1)%3===0"
                  class="dropBody dropBodyRight"
                >
                  <div class="creatPeople">创建人</div>
                  <div class="headerBox">
                    <div class="ceatPeopleInfo">
                      <img v-if="item.member" :src="item.member.avatar" alt />
                      <span v-if="item.member">{{item.member.nickname}}</span>
                    </div>
                  </div>
                  <div class="creatPeople">编辑人员</div>
                  <div class="headerBox">
                    <div class="ceatPeopleInfo" v-for="items in item.editor">
                      <img :src="items.avatar" alt />
                      <span>{{items.nickname}}</span>
                    </div>
                  </div>
                  <div class="border-up-empty"></div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <!-- 知识库-列表 -->
      <div
        class="knowledgeListTable"
        v-else-if="showKnowledgeListType==='2' && knowledgeList.length>0"
      >
        <div class="table">
          <div class="table_head">
            <div class="headerItem" style="width:20%">项目名称</div>
            <div class="headerItem" style="width:26%">内容</div>
            <div class="headerItem" style="width:10%">创建人员</div>
            <div class="headerItem" style="width:16%">更新时间</div>
            <div class="headerItem" style="width:18%; display:flex;justify-content: flex-end;">编辑人员</div>
            <div class="headerItem" style="width:10%;display:flex;justify-content:center">操作</div>
          </div>
          <ul class="table__body">
            <li
              class="tableBodyItem"
              v-for="item in knowledgeList"
              :key="item.id"
              @click="showDetails(item)"
            >
              <div class="bodyItem" style="width:20%">
                <h3 class="knowledgeTitle">{{item.title}}</h3>
                <p>
                  <span style="color:#999">相关项目类型：</span>
                  <span>{{item.project_type}}</span>
                </p>
              </div>
              <div class="bodyItem" style="width:26%">
                <p class="tableItemContent">{{item.content}}</p>
              </div>
              <div class="bodyItem" style="width:10%">
                <p v-if="item.member">{{item.member.nickname}}</p>
                <!-- <p>188888888888</p> -->
              </div>
              <div class="bodyItem" style="width:16%">
                <p>{{item.update_time}}</p>
              </div>
              <div style="width:18%; display:flex;justify-content: flex-end;">
                <img class="headerLogo" v-if="item.member" :src="item.member.avatar" alt />
                <img
                  class="headerLogo"
                  v-if="item.editor.length>=1"
                  :src="item.editor[0].avatar"
                  alt
                />
                <img
                  class="headerLogo"
                  v-if="item.editor.length>=2"
                  :src="item.editor[1].avatar"
                  alt
                />
                <!-- 点击创建人显示信息 -->
                <div class="moreDrop" style="width:46px;height:46px;margin-left: 10px;">
                  <img
                    @click.stop="activeDorpListClick(item.id)"
                    style="width:46px;height:46px;"
                    src="../../assets/image/morePeople.png"
                    alt
                  />
                  <div v-if="activeDorpList == item.id  " class="dropBody">
                    <p class="creatPeople">创建人</p>
                    <div class="headerBox">
                      <div class="ceatPeopleInfo">
                        <img v-if="item.member" :src="item.member.avatar" alt />
                        <span v-if="item.member">{{item.member.nickname}}</span>
                      </div>
                    </div>
                    <p class="creatPeople">编辑人员</p>
                    <div class="headerBox">
                      <div class="ceatPeopleInfo" v-for="items in item.editor">
                        <img :src="items.avatar" alt />
                        <span>{{items.nickname}}</span>
                      </div>
                    </div>
                    <div class="border-up-empty"></div>
                  </div>
                </div>
              </div>
              <div
                style="width:10%;display:flex;justify-content:center;align-items: center;padding-right:0;text-align: center;"
              >
                <el-button
                  style="width:80px;padding:0px;height:30px"
                  @click.stop="removeKnow(item)"
                  :disabled="isAdmin==0 ? false : true"
                >删除</el-button>
              </div>
            </li>
          </ul>
        </div>
        <div class="pageRow">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20, 30]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="Total"
          ></el-pagination>
        </div>
      </div>

      <div v-else class="emptyImg table__body">
        <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
      </div>
    </div>
    <!-- 详情页弹窗 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose"
      class="addClientDia"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span class="title-name" style="color:#128BF1;margin-right:5px">张某某-</span> -->
        <span class="title-age">知识库项目详情</span>
      </div>
      <div class="diaContainer">
        <!-- 按钮行 -->
        <div class="diaBtnRow">
          <el-button
            style="background-color: #ccc;"
            @click="historyClick"
            v-if="detailType=='withEdit'"
          >历史版本</el-button>
          <el-button type="primary" @click="handleEditClick" v-if="detailType=='withEdit'">编辑</el-button>
        </div>
        <div class="yauto">
          <!-- 标题 -->
          <h3 class="knowDetailsTitle">{{addFormData.title}}</h3>
          <!-- 类型 -->
          <p class="knowType">
            <span style="color:#333;font-size:18px">相关项目类型：</span>
            <span>{{addFormData.project_type}}</span>
          </p>
          <!-- 内容 -->
          <div class="diaDetailsInfo">
            <p style="color:#333;font-size:18px;margin-bottom:5px">内容：</p>
            <!-- <p class="infiContainer">{{addFormData.content}}</p> -->
            <!-- 富文本 -->
          </div>
          <!-- <div class="checkDetales ql-editor" v-html="addFormData.content"></div> -->
          <div class="ql-container ql-snow" style="margin:20px 0">
            <div class="ql-editor" v-html="addFormData.content"></div>
          </div>
          <!-- 相关附件 -->
          <p style="color:#333;font-size:18px">相关附件：</p>
          <upload-files
            style="margin:10px 0 30px; width:80%"
            :isSubmit="false"
            :imgList="this.addFormData.annex"
            :detailsImgList="detailsImgList"
            @my-upload-change="upLoadChange"
          ></upload-files>
        </div>
      </div>
    </el-dialog>
    <!--新增 -->
    <el-dialog
      :visible.sync="dialogVisibleadd"
      width="80%"
      :modal-append-to-body="false"
      :before-close="handleCloseAdd"
      class="addClientDia"
      @close="handleClosedAdd"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span class="title-name" style="color:#128BF1;margin-right:5px">张某某-</span> -->
        <span class="title-age" v-if="diaModifyType=='add'">新增知识信息</span>
        <span class="title-age" v-if="diaModifyType=='edit'">编辑知识信息</span>
      </div>
      <div class="diaContainer">
        <div style="box-sizing:border-box;padding-right:15%" class="yauto">
          <el-form ref="form" label-position="left" label-width="140px">
            <el-form-item label="标题">
              <el-input placeholder="请输入标题" v-model="addFormData.title"></el-input>
            </el-form-item>
            <el-form-item label="相关项目类型">
              <el-checkbox-group v-model="addFormData.project_type_arr">
                <el-checkbox
                  v-for="item in projectTypeList"
                  :label="item.project_type_id"
                >{{item.project_type_name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="内容" class="editUpdataBox">
              <!-- <el-input placeholder="请输入内容" type="textarea" v-model="addFormData.content"></el-input> -->
              <!-- <quill-editor
                ref="editQuillEditor"
                class="ql-editor"
                id="editdetailsquill"
                v-model="addFormData.content"
                :options="editorOptionedit"
              ></quill-editor>-->
              <VueUeditorWrap v-model="addFormData.content" :config="myconfig" />

              <el-upload
                class="avatar-uploader avatar-uploader-display"
                action="#"
                ref="addUpLoad"
                :show-file-list="false"
                :before-upload="beforeAvatarUploadEdit"
              >
                <img v-if="addFormData.content" :src="addFormData.content" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="相关附件">
              <upload-file
                :isSubmit="true"
                :imgList="addFormData.annex"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
          </el-form>
        </div>

        <div class="diaBtnRow" style="justify-content: flex-start;margin-bottom:30px">
          <el-button
            type="primary"
            style="margin-left:130px"
            v-if="diaModifyType=='add'"
            @click="addKnowSubmit"
          >新增</el-button>
          <el-button
            type="primary"
            style="margin-left:130px"
            v-if="diaModifyType=='edit'"
            @click="editKnowSubmit"
          >提交</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 历史版本弹窗 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="dialogVisibleHistory"
      width="60%"
      :before-close="handleHistoryClose"
      class="addClientDia"
      @close="handleHistoryClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span class="title-name" style="color:#128BF1;margin-right:5px">张某某-</span> -->
        <span class="title-age">知识库历史版本</span>
      </div>
      <div class="diaHistoryBox">
        <!-- 按钮行 -->
        <div class="diaBtnRow">
          <el-button style="background-color: #ccc;" @click="historyGoBack">返回</el-button>
        </div>
        <!-- 列表 -->
        <div class="knowledgeHisTable">
          <div class="table">
            <div class="table_head">
              <div class="headerItem" style="width:25%">项目名称</div>
              <div class="headerItem" style="width:29%">内容</div>
              <div class="headerItem" style="width:20%">编辑人员</div>
              <div class="headerItem" style="width:16%;text-align:center">更新时间</div>
              <div class="headerItem" style="width:10%;text-align:center">操作</div>
            </div>
            <ul class="table__body">
              <li
                class="tableBodyItem"
                v-for="item in historyList"
                :key="item.id"
                @click="showDetailsHistory(item)"
              >
                <div class="bodyItem" style="width:25%">
                  <h3 class="knowledgeTitle overflowDoit">{{item.title}}</h3>
                  <p class="overflowDoit">
                    <span style="color:#999">相关项目类型：</span>
                    <span>{{item.project_type_show}}</span>
                  </p>
                </div>
                <div class="bodyItem" style="width:29%">
                  <p class="tableItemContent">{{item.content}}</p>
                </div>
                <div class="bodyItem" style="width:20%">
                  <p v-if="item.memberone">{{item.memberone.nickname}}</p>
                </div>
                <div class="bodyItem" style="width:16%;padding-right:0">
                  <p style="text-align:center">{{item.add_time}}</p>
                </div>
                <div
                  style="width:10%; padding-left:20px;display:flex;justify-content:center;align-items: center;padding-right:0"
                >
                  <p
                    style="text-align:center;height:40px;line-height:40px;width:100%"
                    @click.stop="handleHistoryRemove(item)"
                  >删除</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="pageRow">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadFile from '../../components/UploadFile'
import UploadFiles from '../../components/UploadFile'
import VueUeditorWrap from 'vue-ueditor-wrap'

// 引入富文本相关 start
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as Quill from 'quill'
//quill编辑器的字体
var fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
var Font = Quill.import('formats/font')
Font.whitelist = fonts //将字体加入到白名单
Quill.register(Font, true)
//图片缩放
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['clean'], // remove formatting button
]
// 引入富文本相关 end

export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      isAdmin: '',

      detailType: '',
      editId: '',
      diaModifyType: '',
      projectTypeList: [],
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',

      dialogVisible: false,
      dialogVisibleadd: false,
      dialogVisibleHistory: false,
      activeDorpList: '',
      searchInfo1: '',
      detailsImgList: [],
      submitImgList: [],
      showKnowledgeListType: '1',
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      addFormData: {
        title: '',
        content: '',
        project_type_arr: [],
        annex: [],
      },
      knowledgeList: [],
      historyList: [],
      myconfig: {
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: '//ueditor.szcloudplus.com/cos',
        // serverUrl: 'http://35.201.165.105:8000/controller.php',
        serverUrl: this.basURLStr + '/Public/UEditor/php/controller.php',
        // serverUrl: '/UEditor/php/controller.php',
        // 'https://test.control.sxpz.vip/Public/UEditor/php/controller.php',
        // serverUrl: '/UEditor/php/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/',
        // UEDITOR_HOME_URL: this.basURLStr + '/Public/UEditor/',
      },
      editorOptionedit: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // alert('自定义图片')
                  // 调用element图片上传
                  document
                    .querySelector('.editUpdataBox .avatar-uploader-icon')
                    .click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
          imageResize: {}, // 配置图片可缩放大小
        },
      },
      // // todo编辑
    }
  },
  methods: {
    // 富文本上传
    async beforeAvatarUploadEdit(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      let param = new FormData()
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('member_id', this.member_id)
      param.append('file', file)
      // return console.log('param', param.get('access_token'))
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        // data: param,
        data: param,
      })
      // return console.log('res', res)
      if (res.code != 200) return this.$message.error(res.datas.msg)

      let quill = this.$refs.editQuillEditor.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.datas.img_url)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败')
      }
      console.log('asdasdasdas')
      return new Promise((resolve, reject) => {
        this.$refs['addUpLoad'].validate((valid) => {
          if (valid) {
            return resolve(true)
          } else {
            return reject(false)
          }
        })
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.getKnowList()
    },
    // *删除知识库历史
    async handleHistoryRemove(item) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('hid', item.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Knowledge/history_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getHistoryList()
      }
    },
    // *删除知识库
    async removeKnow(item) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('kid', item.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Knowledge/del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getKnowList()
      }
    },
    // *编辑提交
    async editKnowSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('kid', this.addFormData.kid)

        param.append('title', this.addFormData.title)
        param.append('content', this.addFormData.content)
        param.append(
          'project_type',
          this.addFormData.project_type_arr.join(',')
        )
        param.append('annex', JSON.stringify(this.submitImgList))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Knowledge/edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getKnowList()
        this.dialogVisibleadd = false
        this.dialogVisible = false
      }, this.timeDou)
    },
    // 详情后点击编辑
    handleEditClick() {
      console.log(this.addFormData.annex)
      this.diaModifyType = 'edit'
      this.addFormData.annex = this.addFormData.annex
      this.dialogVisibleadd = true
    },
    // *新增知识库提交
    async addKnowSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('title', this.addFormData.title)
        param.append('content', this.addFormData.content)
        param.append(
          'project_type',
          this.addFormData.project_type_arr.join(',')
        )
        param.append('annex', JSON.stringify(this.submitImgList))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Knowledge/add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getKnowList()
        this.dialogVisibleadd = false
      }, this.timeDou)
    },
    // *知识库列表
    async getKnowList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('search', this.searchInfo1)

      param.append('p', 1)
      param.append('p_count', 1000)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Knowledge/index',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.knowledgeList = res.datas.listInfo
      // :disabled="isAdmin==0 ? false : true"
      this.isAdmin = res.datas.admin_state
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    // 历史版本-点击返回
    historyGoBack() {
      this.showDetails({ id: this.editId })
      this.detailType = 'withEdit'
      this.dialogVisibleHistory = false
      this.dialogVisible = true
    },
    // *点击历史版本
    historyClick() {
      this.dialogVisible = false
      this.getHistoryList()
      this.dialogVisibleHistory = true
    },
    async getHistoryList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('kid', this.editId)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Knowledge/history',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.historyList = res.datas.listInfo
    },
    // *知识库详情历史版本详情
    async showDetailsHistory(item) {
      this.detailType = 'withoutEdit'
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('kid', this.editId)
      param.append('hid', item.id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Knowledge/detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addFormData = res.datas.info
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      console.log('知识详情', this.addFormData)
      this.dialogVisible = true
    },
    // *获取知识详情
    async showDetails(item) {
      this.detailType = 'withEdit'
      this.editId = item.id
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('kid', item.id)
      param.append('hid', '')

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Knowledge/detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addFormData = res.datas.info
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      console.log('知识详情', this.addFormData)
      this.dialogVisible = true
    },
    activeDorpListClick(val) {
      if (this.activeDorpList === val) return (this.activeDorpList = '')
      this.activeDorpList = val
    },
    addKnowledgeClick() {
      this.addFormData = {
        title: '',
        content: '',
        project_type_arr: [],
        annex: [],
      }
      this.submitImgList = []
      this.dialogVisibleadd = true
      this.diaModifyType = 'add'
    },
    showKnowledgeListTypeChange(val) {
      this.showKnowledgeListType = val
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.currentPage = 1
      this.getHistoryList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getHistoryList()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {},
    handleHistoryClose() {
      this.dialogVisibleHistory = false
    },
    handleHistoryClosed() {},
    handleCloseAdd() {
      this.dialogVisibleadd = false
    },
    handleClosedAdd() {},
    // 获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      console.log('项目类型列表', this.projectTypeList)
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getProjectTypeList()
    this.getKnowList()
  },
  components: {
    UploadFile,
    UploadFiles,
    VueUeditorWrap,
  },
  watch: {
    addFormData(val, oldVal) {
      console.log('va222222222', val)
      if (val) {
        this.addFormData = val
      }
    },
  },
}
</script>
<style lang="less" scoped>
#knowledgePage {
  height: 92%;
  width: 100%;
  box-sizing: border-box;
  padding: 30px 3.5%;

  .knowledgeContainer {
    height: 100%;
    border-radius: 10px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px 40px;
    box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 30px;
      /deep/.tableSearch {
        width: 450px;
        // (deep)
        .el-input__inner {
          padding-left: 25px;
          height: 45px;
          border-radius: 24px;
          font-size: 16px;
          border: none;
          background-color: #f4f5f6;
          color: #333;
          &::placeholder {
            color: #333;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #333;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #333;
          }
        }
      }
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
        img {
          cursor: pointer;
          margin-left: 30px;
        }
      }
    }
    // 知识库-方块
    .knowledgeListChunk {
      height: calc(100% - 48px - 30px);
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      li {
        cursor: pointer;
        box-sizing: border-box;
        width: 32%;
        margin-right: 2%;
        height: 47%;
        margin-bottom: 2%;
        border-radius: 10px;
        border: 1px solid #efefef;
        h3 {
          border-radius: 10px 10px 0 0;
          font-size: 16px;
          padding: 0 40px;
          padding-right: 20px;
          font-weight: normal;
          color: #999;
          height: 15.5%;
          display: flex;
          align-items: center;
          background-color: #f4f5f6;
          display: flex;
          justify-content: space-between;
          .el-icon-close {
            color: #fff;
            display: none;
          }
        }
        .body {
          width: 100%;
          box-sizing: border-box;
          padding: 0 40px;
          height: 84.5%;
          .bodyTitle {
            color: #333;
            height: 21.5%;
            display: flex;
            align-items: center;
            font-size: 20px;
            // font-weight: bold;
          }
          .containerp {
            min-height: 44px;
          }
          p {
            font-size: 16px;
            color: #666;
            width: 100%;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .creatPeople {
            box-sizing: border-box;
            width: 100%;
            height: calc((78.5% - 66px) / 2);
            border-bottom: 1px solid #ebebeb;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #333;
            img {
              height: 35px;
              width: 35px;
              border-radius: 50%;
              margin-right: 20px;
            }
            // 知识库-方块创建人下拉框
            .moreDrop {
              position: relative;
              .dropBody {
                position: absolute;
                right: -340px;
                top: -100px;
                z-index: 99;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.11);
                box-sizing: border-box;
                padding: 20px;
                padding-bottom: 0;
                width: 320px;
                // height: 360px;
                border-radius: 5px;
                .creatPeople {
                  font-size: 16px;
                  font-weight: 400;
                  color: #128bf1;
                  border-bottom: none;
                  display: flex;
                  align-items: center;
                }
                .headerBox {
                  width: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  box-sizing: border-box;
                  padding: 0 10px;
                  padding-top: 20px;
                  .ceatPeopleInfo {
                    width: 50%;
                    display: flex;
                    padding-bottom: 20px;
                    align-items: center;
                    img {
                      margin-right: 0;
                      width: 46px;
                      height: 46px;
                      border-radius: 23px;
                    }
                    span {
                      font-size: 14px;
                      color: #666666;
                      margin-left: 11px;
                    }
                  }
                }
                .creatPeople::before {
                  content: '';
                  display: block;
                  width: 2px;
                  height: 14px;
                  background-color: #40a0f2;
                  margin-right: 10px;
                }

                .border-up-empty::after {
                  content: '';
                  position: absolute;
                  right: 310px;
                  top: 110px;
                  width: 0;
                  height: 0px;
                  border-style: solid;
                  border-width: 10px;
                  border-color: #fff #fff transparent transparent;
                  transform: rotate(-135deg);
                  box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
                }
              }
              .dropBodyRight {
                left: -340px;
                .border-up-empty::after {
                  content: '';
                  position: absolute;
                  top: 110px;
                  left: 310px;
                  width: 0;
                  height: 0px;
                  border-style: solid;
                  border-width: 10px;
                  border-color: #fff #fff transparent transparent;
                  transform: rotate(-315deg);
                  box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
                }
              }
            }
          }
        }
      }
      li:nth-child(3n + 3) {
        margin-right: 0 !important;
      }
      li:hover {
        box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
        h3 {
          background-color: #40a0f2;
          color: #fff;
        }

        .bodyTitle {
          color: #128bf1 !important;
        }
        .el-icon-close {
          display: block;
        }
      }
    }
    // 知识库-列表
    .knowledgeListTable {
      width: 100%;
      height: calc(100% - 48px - 30px);
      .table {
        width: 100%;
        height: calc(100% - 30px);
        .table_head {
          box-sizing: border-box;
          padding: 0 40px;
          width: 100%;
          height: 9%;
          font-size: 18px;
          color: #fff;
          background-color: #40a0f2;
          display: flex;
          align-items: center;
        }
        .table__body {
          box-sizing: border-box;
          height: 91%;
          width: 100%;
          overflow-y: auto;
          padding: 0 2px;
          // li
          .tableBodyItem {
            cursor: pointer;
            box-sizing: border-box;
            padding: 17px 40px;
            border-bottom: 1px solid #ebebeb;
            width: 100%;
            display: flex;
            .bodyItem {
              box-sizing: border-box;
              padding-right: 30px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .knowledgeTitle {
                margin-bottom: 4px;
                font-size: 18px;
                color: #333333;
                font-weight: normal;
              }
              p {
                font-size: 16px;
                color: #666666;
              }
              .tableItemContent {
                width: 100%;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
            // 知识库-列表创建人下拉框
            .moreDrop {
              position: relative;
              .dropBody {
                position: absolute;
                left: -340px;
                top: -10px;
                z-index: 99;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.11);
                box-sizing: border-box;
                padding: 20px;
                padding-bottom: 0;
                width: 320px;
                // height: 360px;
                border-radius: 5px;
                .creatPeople {
                  font-size: 16px;
                  font-weight: 400;
                  color: #128bf1;
                  display: flex;
                  align-items: center;
                }
                .headerBox {
                  width: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  box-sizing: border-box;
                  padding: 0 10px;
                  padding-top: 20px;
                  .ceatPeopleInfo {
                    width: 50%;
                    display: flex;
                    padding-bottom: 20px;
                    align-items: center;
                    img {
                      width: 46px;
                      height: 46px;
                      border-radius: 23px;
                    }
                    span {
                      font-size: 14px;
                      color: #666666;
                      margin-left: 11px;
                    }
                  }
                }
                .creatPeople::before {
                  content: '';
                  display: block;
                  width: 2px;
                  height: 14px;
                  background-color: #40a0f2;
                  margin-right: 10px;
                }
                .border-up-empty::after {
                  content: '';
                  position: absolute;
                  left: 310px;
                  top: 20px;
                  width: 0;
                  height: 0px;
                  border-style: solid;
                  border-width: 10px;
                  border-color: #fff #fff transparent transparent;
                  transform: rotate(-315deg);
                  box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
                }
              }
            }
            .headerLogo {
              width: 46px;
              height: 46px;
              border-radius: 50%;
              margin-left: 10px;
            }
          }
          .tableBodyItem:hover {
            box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
            .knowledgeTitle {
              color: #128bf1;
            }
          }
        }
      }

      // 分页行
      .pageRow {
        height: 20px;
        box-sizing: border-box;
        margin-top: 20px;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        /deep/.el-pagination .el-select .el-input .el-input__inner {
          font-size: 14px;
        }
        /deep/.el-pagination button,
        /deep/.el-pagination span:not([class*='suffix']) {
          font-size: 14px;
        }
      }
    }
  }

  // 修改新增formItem样式
  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 40px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    // display: flex;
    /deep/.el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: 18px;
      }
    }
    .el-input__inner {
      font-size: 14px;
      width: 100%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 100%;
      .el-textarea__inner {
        height: 170px;
        font-size: 14px;
        resize: none;
        border-radius: 0;
      }
    }
  }
  /deep/.upload-demo {
    margin-bottom: 0px !important;
  }
}
// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
  // 知识库详情主体内容
  .diaContainer {
    width: 100%;
    box-sizing: border-box;
    padding-left: 80px;
    // 按钮行
    .diaBtnRow {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .el-button {
        height: 46px;
        padding: 0 40px;
        font-size: 20px;
        font-weight: normal;
        color: #fff;
        border: none;
        border-radius: 25px;
        background-color: #40a0f2;
        margin-bottom: 10px;
      }
      .el-button:first-child {
        margin-right: 2%;
      }
    }
    // 标题
    .knowDetailsTitle {
      width: calc(100% - 80px);
      padding-left: -80px;
      text-align: center;
      font-size: 22px;
      color: #333333;
      font-weight: 400;
      margin: 20px 0;
    }
    // 知识类型
    .knowType {
      font-size: 16px;
      color: #666;
      margin-bottom: 30px;
    }
    // 内容
    .diaDetailsInfo {
      width: calc(90% - 100px);
      .infiContainer {
        max-height: 35vh;
        overflow-y: auto;
        margin-bottom: 30px;
      }
    }
    // 附件
    .adjunctBox {
      width: 80%;
      margin: 20px 0;
      display: flex;
      flex-wrap: wrap;
      li {
        width: 150px;
        height: 120px;
        border: 1px solid #efefef;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 20px;
        margin-bottom: 20px;
        .pdfImg {
          margin-top: 25px;
          margin-bottom: 10px;
          width: 40px;
        }
        .pdfName {
          width: 80%;
          overflow: hidden; /*超出部分隐藏*/
          white-space: nowrap; /*不换行*/
          text-overflow: ellipsis; /*超出部分文字以...显示*/
        }
      }
    }
  }
  // 知识库历史
  .diaHistoryBox {
    // 按钮行
    .diaBtnRow {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .el-button {
        height: 46px;
        padding: 0 40px;
        font-size: 20px;
        font-weight: normal;
        color: #fff;
        border: none;
        border-radius: 25px;
        background-color: #40a0f2;
        margin-bottom: 10px;
      }
      .el-button:first-child {
        margin-right: 2%;
      }
    }
    // 表格行
    .knowledgeHisTable {
      width: 100%;
      .table {
        width: 100%;
        height: 68vh;
        .table_head {
          box-sizing: border-box;
          padding: 0 40px;
          width: 100%;
          height: 60px;
          font-size: 18px;
          color: #fff;
          background-color: #40a0f2;
          display: flex;
          align-items: center;
        }
        .table__body {
          box-sizing: border-box;
          height: 91%;
          width: 100%;
          overflow-y: auto;
          padding: 0 2px;
          // li
          .tableBodyItem {
            cursor: pointer;
            box-sizing: border-box;
            padding: 17px 40px;
            border-bottom: 1px solid #ebebeb;
            width: 100%;
            display: flex;
            .bodyItem {
              box-sizing: border-box;
              padding-right: 30px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .knowledgeTitle {
                margin-bottom: 4px;
                font-size: 18px;
                color: #333333;
              }
              p {
                font-size: 14px;
                color: #666666;
              }
              .tableItemContent {
                width: 100%;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .overflowDoit {
                width: 100%;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
            }
            // 知识库-列表创建人下拉框
            .moreDrop {
              position: relative;
              .dropBody {
                position: absolute;
                left: -340px;
                top: -10px;
                z-index: 99;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.11);
                box-sizing: border-box;
                padding: 20px;
                padding-bottom: 0;
                width: 320px;
                // height: 360px;
                border-radius: 5px;
                .creatPeople {
                  font-size: 16px;
                  font-weight: 400;
                  color: #128bf1;
                  display: flex;
                  align-items: center;
                }
                .headerBox {
                  width: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  box-sizing: border-box;
                  padding: 0 10px;
                  padding-top: 20px;
                  .ceatPeopleInfo {
                    width: 50%;
                    display: flex;
                    padding-bottom: 20px;
                    align-items: center;
                    img {
                      width: 46px;
                      height: 46px;
                      border-radius: 23px;
                    }
                    span {
                      font-size: 14px;
                      color: #666666;
                      margin-left: 11px;
                    }
                  }
                }
                .creatPeople::before {
                  content: '';
                  display: block;
                  width: 2px;
                  height: 14px;
                  background-color: #40a0f2;
                  margin-right: 10px;
                }
                .border-up-empty::after {
                  content: '';
                  position: absolute;
                  left: 310px;
                  top: 20px;
                  width: 0;
                  height: 0px;
                  border-style: solid;
                  border-width: 10px;
                  border-color: #fff #fff transparent transparent;
                  transform: rotate(-315deg);
                  box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
                }
              }
            }
            .headerLogo {
              width: 46px;
              height: 46px;
              border-radius: 50%;
              margin-left: 10px;
            }
          }
          .tableBodyItem:hover {
            box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
            .knowledgeTitle {
              color: #128bf1;
            }
          }
        }
      }

      // 分页行
      .pageRow {
        height: 20px;
        box-sizing: border-box;
        margin-top: 10px;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        /deep/.el-pagination .el-select .el-input .el-input__inner {
          font-size: 14px;
        }
        /deep/.el-pagination button,
        /deep/.el-pagination span:not([class*='suffix']) {
          font-size: 14px;
        }
      }
    }
  }
}
.addClientDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 5vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
.avatar-uploader-display {
  display: none;
}
/deep/ .quill-editor {
  padding: 0;
}
/deep/.ql-container {
  font-size: inherit;
}
.checkDetales {
  width: 100%;
  margin-bottom: 20px;
}
.yauto {
  height: calc(80vh - 70px);
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

.table__body::-webkit-scrollbar {
  width: 5px !important;
}
.table__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.table__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

.knowledgeListChunk::-webkit-scrollbar {
  width: 5px !important;
}
.knowledgeListChunk::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.knowledgeListChunk::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

.ql-container {
  width: 95%;
  height: initial;
}
/deep/.v-modal {
  z-index: 400 !important;
}
/deep/.el-dialog__wrapper {
  z-index: 500 !important;
}
</style>